import PropTypes from 'prop-types';
import {GoogleReCaptchaProvider} from 'react-google-recaptcha-v3';

const AppReCaptcha = ({children}) => {
  const CONFIG_RECAPTCHA_SITE_KEY = window.CONFIG_RECAPTCHA_SITE_KEY;

  return (
    <GoogleReCaptchaProvider reCaptchaKey={CONFIG_RECAPTCHA_SITE_KEY}>
      {children}
    </GoogleReCaptchaProvider>
  );
};

export default AppReCaptcha;

AppReCaptcha.propTypes = {
  children: PropTypes.node,
};
